var render = function (_h,_vm) {var _c=_vm._c;return _c('li',_vm._g({staticClass:"base-list__item px-4",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass])},_vm.data.on),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }